<template>
	<div slot="no-body">
		<div
			class="p-6"
			:class="{
				'flex justify-between flex-row-reverse items-center': false,
				'text-center': !iconRight,
				'pb-0': !iconRight,
			}"
		>
			<div>
				<h5 class="mb-1 font-bold">
					{{ visit_point_local.name | mayus }}
				</h5>
				<span>{{ visit_point_local.address }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import VisitPoint from "@/models/VisitPoint.js";
import BridgeInstance from "./bridgeInstance";

export default {
	props: {
		visit_point: {
			type: Object,
			default: () => new VisitPoint({}),
		},
	},
	data() {
		return {
			visit_point_local: this.visit_point,
			iconRight: false,
			hideChart: false,
		};
	},
	filters: {
		mayus(val) {
			return val.toUpperCase();
		},
	},
};
</script>
